import React from 'react'
import { ColumnProps } from 'antd/es/table'
import { DateUtils } from 'submodules/nerit-framework-utils/utils/date/DateUtils'
import { DateFormatEnum } from 'submodules/nerit-framework-utils/utils/enums/DateFormatEnum'
import { ButtonCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonCP'
import { TagCP } from 'submodules/nerit-framework-ui/common/components/tag/TagCP'
import { ButtonGroupCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonGroupCP'
import { ButtonCancelQAQCCP } from 'modules/reports/screens/screen-charts/content/qaqc/ButtonCancelQAQCCP'
import { ButtonViewQAQCExecutionFiltersCP } from 'modules/reports/screens/screen-charts/content/qaqc/ButtonViewQAQCExecutionFiltersCP'
import { ButtonViewQAQCResultCP } from 'modules/reports/screens/screen-charts/content/qaqc/ButtonViewQAQCResultCP'
import { ButtonExportQAQCResultCP } from 'modules/reports/screens/screen-charts/content/qaqc/ButtonExportQAQCResultCP'
import { QAQCRequests } from 'submodules/nerit-aquatec-sdk/services/qaqc/QAQCRequests'
import { QAQCListItemResponseDTO } from 'submodules/nerit-aquatec-sdk/services/qaqc/dtos/response/QAQCListItemResponseDTO'
import { NeritFrameworkRoutingHelper } from 'submodules/nerit-framework-ui/common/router/utils/NeritFrameworkRoutingHelper'
import { QAQCStatusEnum, QAQCStatusLabelEnum } from 'submodules/nerit-aquatec-sdk/common/enums/QAQCStatusEnum'
import { QAQCExecutionTypeEnum } from 'submodules/nerit-aquatec-sdk/common/enums/QAQCExecutionTypeEnum'

export const QAQCTableUtils = {

	getTableColumns(
		onCancel: () => void,
		executionType: QAQCExecutionTypeEnum,
	): Array<ColumnProps<QAQCListItemResponseDTO>> {
		return [
			{
				title: 'Identificação',
				dataIndex: 'identification',
				render: (text: string) => text,
			},
			{
				title: 'Data de Execução',
				dataIndex: 'executionDate',
				render: (text: string) => text ? DateUtils.formatDate(text, DateFormatEnum.BR_WITH_TIME_H_M_S_DEFAULT) : '-',
			},
			{
				title: 'Executado por',
				dataIndex: 'creationPerson',
				render: (creationPerson: { name?: string }) => creationPerson?.name ?? '-',
			},
			{
				title: 'Status',
				dataIndex: 'status',
				render: (status: QAQCStatusEnum) => (
					<TagCP
						content={QAQCStatusLabelEnum[status]}
						color={status === QAQCStatusEnum.CANCELLED ? 'red' : 'green'}
					/>
				),
			},
			{
				title: 'Amostras Aprovadas',
				dataIndex: 'totalApprovedSamples',
				render: (val: number) => val ?? 0,
			},
			{
				title: 'Amostras Reprovadas',
				dataIndex: 'totalRejectedSamples',
				render: (val: number) => val ?? 0,
			},
			{
				title: 'Total',
				render: (_: any, record: QAQCListItemResponseDTO) =>
					(record.totalApprovedSamples ?? 0) + (record.totalRejectedSamples ?? 0),
			},
			{
				title: 'Informações Detalhadas',
				render: (_: any, record: QAQCListItemResponseDTO) => (
					<ButtonGroupCP mode={'separeted'}>
						<ButtonViewQAQCResultCP
							executionCode={record.code}
							identification={record.identification}
						/>
						<ButtonViewQAQCExecutionFiltersCP executionCode={record.code} />
						{executionType !== QAQCExecutionTypeEnum.IONIC_BALANCE && (
							<ButtonExportQAQCResultCP executionCode={record.code} fileLabel={record.identification} />
						)}
						{(!!record.logSignedUrl || !!record.logPath) && (
							<ButtonCP
								tooltip={'Baixar logs'}
								icon={'download'}
								onClick={() => NeritFrameworkRoutingHelper.openInNewTab(record.logSignedUrl ?? record.logPath ?? '')}
								size={'small'}
								type={'ghost'}
							/>
						)}
						{record.status !== QAQCStatusEnum.CANCELLED && (
							<ButtonCancelQAQCCP
								requestConfigTP={() => QAQCRequests.cancel(record.code)}
								onCancel={onCancel}
							/>
						)}
					</ButtonGroupCP>
				),
			},
		]
	},
}
